import React from 'react';
import { StyleSheet, View } from 'react-native';
import {
  ActivityIndicator,
  Button,
  Divider,
  Text
} from 'react-native-paper';

interface ShareItemModalHeaderProps {
  sourceItemName: string;
}

export const ShareItemModalHeader: React.FC<ShareItemModalHeaderProps> = ({
  sourceItemName
}) => (
  <>
    <Text style={styles.title}>Share Item: {sourceItemName}</Text>
    <Text style={styles.subtitle}>
      Link this item to another template so reviews can share data
    </Text>
    <Divider style={styles.divider} />
  </>
);

interface ShareItemDetoxControlsProps {
  enabled: boolean;
  canSelectFirstTarget: boolean;
  canCreateSelectedLink: boolean;
  canCreateFirstLink: boolean;
  loading: boolean;
  onSelectFirstTarget: () => void;
  onCreateSelectedLink: () => void;
  onCreateFirstLink: () => void;
}

export const ShareItemDetoxControls: React.FC<ShareItemDetoxControlsProps> = ({
  enabled,
  canSelectFirstTarget,
  canCreateSelectedLink,
  canCreateFirstLink,
  loading,
  onSelectFirstTarget,
  onCreateSelectedLink,
  onCreateFirstLink
}) => {
  if (!enabled) {
    return null;
  }

  return (
    <>
      {canSelectFirstTarget && (
        <Button
          testID="share-detox-select-first-target-button"
          mode="outlined"
          onPress={onSelectFirstTarget}
          style={styles.selector}
        >
          Select First Target
        </Button>
      )}

      {canCreateSelectedLink && (
        <Button
          testID="share-detox-create-link-button"
          mode="contained"
          onPress={onCreateSelectedLink}
          disabled={loading}
          loading={loading}
          style={styles.selector}
        >
          Create Link
        </Button>
      )}

      {canCreateFirstLink && (
        <Button
          testID="share-detox-create-first-link-button"
          mode="contained"
          onPress={onCreateFirstLink}
          disabled={loading}
          loading={loading}
          style={styles.selector}
        >
          Create First Link
        </Button>
      )}
    </>
  );
};

interface ShareItemModalActionsProps {
  loading: boolean;
  canCreateLink: boolean;
  onCancel: () => void;
  onCreateLink: () => void;
}

export const ShareItemModalActions: React.FC<ShareItemModalActionsProps> = ({
  loading,
  canCreateLink,
  onCancel,
  onCreateLink
}) => (
  <View style={styles.actions}>
    <Button
      testID="share-cancel-button"
      mode="outlined"
      onPress={onCancel}
      disabled={loading}
      style={styles.button}
    >
      Cancel
    </Button>
    <Button
      testID="share-create-link-button"
      mode="contained"
      onPress={onCreateLink}
      disabled={!canCreateLink || loading}
      loading={loading}
      style={styles.button}
    >
      Create Link
    </Button>
  </View>
);

interface ShareItemLoadingOverlayProps {
  visible: boolean;
}

export const ShareItemLoadingOverlay: React.FC<ShareItemLoadingOverlayProps> = ({
  visible
}) => {
  if (!visible) {
    return null;
  }

  return (
    <View style={styles.loadingOverlay}>
      <ActivityIndicator size="large" />
      <Text style={styles.loadingText}>Creating share link...</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 8
  },
  subtitle: {
    fontSize: 14,
    color: '#666',
    marginBottom: 16
  },
  divider: {
    marginVertical: 16
  },
  selector: {
    width: '100%'
  },
  actions: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
    gap: 12
  },
  button: {
    flex: 1
  },
  loadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 8
  },
  loadingText: {
    marginTop: 12,
    fontSize: 14,
    color: '#666'
  }
});
